/* B.LÊM · Rebrand — página de produto */
(() => {
  const root = document.querySelector('[data-rp]');
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const L = JSON.parse(root.querySelector('[data-i18n]').textContent);
  const fmt = c => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);

  /* ---------- Galeria ---------- */
  const stage = root.querySelector('[data-stage]');
  const slides = [...root.querySelectorAll('[data-slide]')];
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  const dots = [...root.querySelectorAll('.rp-dots span')];
  const prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]'), count = root.querySelector('[data-count]');
  let cur = Math.max(0, slides.findIndex(s => s.classList.contains('is-on')));
  const go = i => {
    if (i < 0 || i >= slides.length || i === cur && slides[i].classList.contains('is-on')) return;
    const dir = i > cur ? 1 : -1; cur = i;
    slides.forEach((s, n) => { s.classList.toggle('is-on', n === i); s.style.setProperty('--dir', dir); });
    thumbs.forEach((t, n) => { t.classList.toggle('is-on', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
    stage.classList.toggle('is-photo', slides[i].hasAttribute('data-photo'));
    stage.classList.remove('is-zoom');
    if (count) count.textContent = i + 1;
    if (prev) prev.disabled = i === 0; if (next) next.disabled = i === slides.length - 1;
  };
  if (slides[cur]) stage.classList.toggle('is-photo', slides[cur].hasAttribute('data-photo'));
  thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.thumb)));
  prev && prev.addEventListener('click', e => { e.stopPropagation(); go(cur - 1); });
  next && next.addEventListener('click', e => { e.stopPropagation(); go(cur + 1); });
  let sx = null, sy = 0;
  stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
  stage.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
  /* lupa (computador) */
  const zoomOk = matchMedia('(hover:hover) and (pointer:fine) and (min-width:1000px)');
  stage.addEventListener('click', e => { if (!zoomOk.matches || e.target.closest('button')) return; stage.classList.toggle('is-zoom'); move(e); });
  const move = e => { if (!stage.classList.contains('is-zoom')) return; const r = stage.getBoundingClientRect(); const img = slides[cur] && slides[cur].querySelector('img'); if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; };
  stage.addEventListener('mousemove', move);
  stage.addEventListener('mouseleave', () => stage.classList.remove('is-zoom'));
  /* paralaxe subtil da garrafa */
  if (zoomOk.matches && !reduce) stage.addEventListener('pointermove', e => { if (stage.classList.contains('is-zoom')) return; const r = stage.getBoundingClientRect(); stage.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5).toFixed(3)); stage.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5).toFixed(3)); });
  stage.addEventListener('pointerleave', () => { stage.style.setProperty('--mx', 0); stage.style.setProperty('--my', 0); });

  /* ---------- Variantes ---------- */
  const idIn = root.querySelector('[data-id]'), priceEl = root.querySelector('[data-price]'), add = root.querySelector('[data-add]'), addL = root.querySelector('[data-add-l]'), addP = root.querySelector('[data-add-p]'), msg = root.querySelector('[data-msg]'), qty = root.querySelector('[data-qty]'), barP = root.querySelector('[data-bar-p]');
  const pick = () => { const sel = [...root.querySelectorAll('.rp-sizes')].map(f => (f.querySelector('input:checked') || {}).value); return variants.find(v => v.options.every((o, i) => sel[i] === undefined || o === sel[i])) || variants[0]; };
  const tick = el => { if (!el || reduce) return; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); };
  const update = (syncUrl = true) => {
    const v = pick(); idIn.value = v.id;
    priceEl.textContent = fmt(v.price); tick(priceEl);
    if (addP) addP.textContent = fmt(v.price * Math.max(1, parseInt(qty.value, 10) || 1));
    const was = root.querySelector('[data-was]'), bdg = root.querySelector('[data-badge]'), sale = v.compare_at_price && v.compare_at_price > v.price;
    if (was) { was.hidden = !sale; was.textContent = sale ? fmt(v.compare_at_price) : ''; }
    if (bdg) { bdg.hidden = !sale; bdg.textContent = sale ? '−' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; }
    add.disabled = !v.available; addL.textContent = v.available ? L.add : L.out;
    if (barP) barP.textContent = (variants.length > 1 ? v.title + ' · ' : '') + fmt(v.price);
    const m = (v.title.match(/\d+/) || [])[0]; const si = slides.findIndex(s => s.dataset.size === m); if (si > -1) go(si);
    if (syncUrl) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); }
  };
  root.querySelectorAll('[data-opt]').forEach(r => r.addEventListener('change', () => update()));
  { const v = pick(); const m = (v.title.match(/\d+/) || [])[0]; const si = slides.findIndex(s => s.dataset.size === m); if (si > 0) go(si); }
  const syncQty = () => { const v = pick(); if (addP) addP.textContent = fmt(v.price * Math.max(1, parseInt(qty.value, 10) || 1)); };
  root.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => { qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.q)); syncQty(); }));
  qty && qty.addEventListener('input', syncQty);

  /* ---------- Adicionar ao carrinho ---------- */
  const form = root.querySelector('[data-form]');
  form.addEventListener('submit', async e => {
    e.preventDefault(); if (add.disabled) return;
    add.disabled = true; addL.textContent = L.adding; msg.hidden = true; add.classList.add('is-busy');
    const img = (slides[cur] && !slides[cur].hasAttribute('data-photo') ? slides[cur] : slides[0] || {}).querySelector?.('img');
    try {
      if (window.rxCart) await window.rxCart.add([{ id: +idIn.value, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }], { img, opener: add });
      else { form.submit(); return; }
      add.classList.add('is-done'); addL.textContent = L.added;
      setTimeout(() => { add.classList.remove('is-done'); addL.textContent = L.add; }, 1800);
    } catch (err) { msg.textContent = err.message || L.err; msg.hidden = false; addL.textContent = L.add; }
    finally { add.classList.remove('is-busy'); add.disabled = !pick().available; }
  });

  /* ---------- Barra fixa ---------- */
  const bar = root.querySelector('[data-bar]');
  if (bar && 'IntersectionObserver' in window) {
    const bb = bar.querySelector('[data-bar-add]');
    bb.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : add.click());
    let addOut = false, footIn = false;
    const sync = () => { const on = addOut && !footIn; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', ''); };
    new IntersectionObserver(([e]) => { addOut = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(add);
    const ft = document.querySelector('.rf'); if (ft) new IntersectionObserver(([e]) => { footIn = e.isIntersecting; sync(); }).observe(ft);
  }

  /* ---------- Acordeões com altura animada ---------- */
  root.querySelectorAll('.rp-acc details').forEach(d => {
    const s = d.querySelector('summary'), b = d.querySelector('.rp-acc__b');
    s.addEventListener('click', e => {
      if (reduce || !b.animate) return;
      e.preventDefault();
      if (d.open) {
        const a = b.animate([{ height: b.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.23,1,.32,1)' });
        d.classList.add('is-closing'); a.onfinish = () => { d.open = false; d.classList.remove('is-closing'); };
      } else {
        d.open = true; const h = b.offsetHeight;
        b.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.23,1,.32,1)' });
      }
    });
  });

  /* ---------- Três tamanhos ---------- */
  const sz = root.querySelector('[data-rp-sizes]');
  if (sz) {
    const tabs = [...sz.querySelectorAll('[data-sz]')], bs = [...sz.querySelectorAll('[data-szb]')];
    let sel = tabs.find(t => t.classList.contains('is-on')) || tabs[tabs.length - 1];
    const show = t => { sel = t; tabs.forEach(x => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); }); bs.forEach(b => b.classList.toggle('is-on', b.dataset.szb === t.dataset.sz)); };
    tabs.forEach(t => t.addEventListener('click', () => show(t)));
    const pickBtn = sz.querySelector('[data-sz-pick]');
    pickBtn && pickBtn.addEventListener('click', () => {
      const r = [...root.querySelectorAll('[data-opt]')].find(x => x.value === sel.dataset.val);
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      root.querySelector('.rp-grid').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => add.focus({ preventScroll: true }), reduce ? 0 : 700);
    });
  }
})();

/* Origem: o mapa desenha-se quando a secção entra no ecrã */
(() => {
  const og = document.querySelector('[data-rp-og]');
  if (!og) return;
  const show = () => og.classList.add('is-in');
  if (!('IntersectionObserver' in window)) return show();
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { show(); io.disconnect(); } }), { threshold: 0.3 });
  io.observe(og);
  setTimeout(show, 9000);
})();
